<template>
  <div class="wrapper">
    <div class="page_header">
      <div class="title_row">
        <h2 class="page_title">
          度假打工遇有我國違(非)法私立就業服務機構申訴資訊
        </h2>
        <a
          class="download_btn"
          href="/files/labor-holiday-work-complaint-info.odt"
          download="度假打工遇有我國違反(非)法私立就業服務機構申訴資訊.odt"
        >
          申訴文件下載 <DownloadOutlined />
        </a>
      </div>
      <div class="meta_row">
        <span class="meta_item">
          <BankOutlined />
          業管單位：勞動部
        </span>
        <span class="meta_item">
          <CalendarOutlined />
          發布日期：2026-03-04
        </span>
      </div>
    </div>

    <div class="content_body">
      <section class="evidence_section">
        <h3 class="section_title">
          <img class="section_icon" :src="attachFileIcon" alt="" />
          申訴時建議備妥之相關佐證資料
        </h3>
        <div class="evidence_grid">
          <div class="evidence_card">
            <p class="evidence_title">公司名稱及所在地</p>
            <img class="evidence_icon" :src="locationIcon" alt="" />
          </div>
          <div class="evidence_card">
            <p class="evidence_title">契約書</p>
            <img class="evidence_icon" :src="contractIcon" alt="" />
          </div>
          <div class="evidence_card">
            <p class="evidence_title">廣告內容</p>
            <p class="evidence_desc">網頁截圖、紙本文宣等</p>
            <img class="evidence_icon" :src="megaphoneIcon" alt="" />
          </div>
          <div class="evidence_card">
            <p class="evidence_title">聯絡內容</p>
            <p class="evidence_desc">
              電子郵件、紙本書信、<br />通訊軟體截圖等
            </p>
            <img class="evidence_icon" :src="securityIcon" alt="" />
          </div>
        </div>
      </section>

      <section class="filing_section">
        <h3 class="section_title">
          <img class="section_icon" :src="sendIcon" alt="" />
          申訴方式
        </h3>

        <div class="online_card">
          <div class="online_content">
            <span class="tag_best">最推薦</span>
            <h4 class="online_title">線上申訴 Online Filing</h4>
            <p class="online_desc">
              可至勞動部民意信箱併上述建議應備佐證資料之電子檔案進行線上申訴。<br />
              (<a
                href="https://po.mol.gov.tw/WriteMail"
                target="_blank"
                rel="noopener"
                >https://po.mol.gov.tw/WriteMail</a
              >)
            </p>
            <a
              class="online_btn"
              href="https://po.mol.gov.tw/WriteMail"
              target="_blank"
              rel="noopener"
            >
              立刻前往線上申訴
              <img class="online_btn_icon" :src="complaintLinkIcon" alt="" />
            </a>
          </div>
          <div class="online_illustration" aria-hidden="true">
            <img class="online_illustration_img" :src="filingIcon" alt="" />
          </div>
        </div>

        <div class="filing_grid">
          <div class="filing_card">
            <div class="filing_icon">
              <MailOutlined />
            </div>
            <h4 class="filing_title">書面申訴 Written Filing</h4>
            <p class="filing_desc">
              可利用下列申訴表格下載區附所有表格或其他任何形式之申請書，併上述建議應備佐證資料，傳真或郵寄至勞動部。
            </p>
            <div class="filing_info">
              <p class="info_label">傳真號碼：</p>
              <p class="info_value">(02)8995-6245</p>
            </div>
            <div class="filing_info">
              <p class="info_label">郵寄地址：</p>
              <p class="info_value">新北市新莊區中平路439號南棟4樓</p>
            </div>
          </div>

          <div class="filing_card">
            <div class="filing_icon">
              <PhoneOutlined />
            </div>
            <h4 class="filing_title">電話申訴 Telephone Filing</h4>
            <p class="filing_desc">
              如果您有個別困難，無法提出書面申訴或線上申訴，請撥打勞動部勞動力發展署「台灣就業通」客服專線：
            </p>
            <p class="phone_number">0800-777-888</p>
            <div class="filing_info">
              <p class="info_label">服務時間：</p>
              <p class="info_value">週一至週五（不含國定假日，08:30~18:30）</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import {
  DownloadOutlined,
  BankOutlined,
  CalendarOutlined,
  MailOutlined,
  PhoneOutlined,
} from "@ant-design/icons-vue";
import attachFileIcon from "../img/complaint_attach_file.png";
import sendIcon from "../img/complaint_send.png";
import locationIcon from "../img/location.png";
import contractIcon from "../img/contract.png";
import megaphoneIcon from "../img/megaphone.png";
import securityIcon from "../img/security.png";
import complaintLinkIcon from "../img/complaint_link.png";
import filingIcon from "../img/complaint_filing.png";

export default defineComponent({
  name: "FraudNoticeComplaint",
  components: {
    DownloadOutlined,
    BankOutlined,
    CalendarOutlined,
    MailOutlined,
    PhoneOutlined,
  },
  setup() {
    return {
      attachFileIcon,
      sendIcon,
      locationIcon,
      contractIcon,
      megaphoneIcon,
      securityIcon,
      complaintLinkIcon,
      filingIcon,
    };
  },
});
</script>

<style lang="scss" scoped>
.wrapper {
  text-align: left;
  margin: 20px 0 100px;
}

.page_header {
  border-bottom: 1px solid var(--border, rgba(226, 232, 240, 1));
  padding-bottom: 20px;
  margin-bottom: 24px;

  .title_row {
    @include flex_between();
    margin-bottom: 16px;
    gap: 16px;
    @include xs {
      flex-direction: column;
      align-items: flex-start;
    }

    .page_title {
      @include flex_center();
      font-size: 36px;
      font-weight: 500;
      font-family: "Noto Sans TC";
      color: #000000d9;
      :deep(svg) {
        margin-right: 10px;
        color: $main_color;
      }
    }

    .download_btn {
      @include flex_center();
      background-color: $main_color;
      color: #ffffff;
      padding: 16px 40px;
      font-size: 16px;
      font-weight: 700;
      font-family: "Noto Sans";
      white-space: nowrap;
      :deep(svg) {
        margin-left: 8px;
      }
      &:hover {
        opacity: 0.85;
      }
    }
  }

  .meta_row {
    display: flex;
    flex-wrap: wrap;
    gap: 8px 32px;

    .meta_item {
      @include flex_center();
      font-size: 14px;
      font-family: "Noto Sans TC";
      font-weight: 500;
      color: #64748b;
      :deep(svg) {
        margin-right: 8px;
      }
    }
  }
}

.content_body {
  .section_title {
    @include flex_center();
    justify-content: flex-start;
    font-size: 24px;
    font-weight: 700;
    font-family: "Noto Sans TC";
    color: #000000d9;
    margin-bottom: 20px;

    .section_icon {
      align-self: center;
      width: 24px;
      height: 24px;
      margin-right: 8px;
      display: block;
    }
  }

  .evidence_section {
    margin-bottom: 48px;
  }

  .evidence_grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 20px;
    @include xl {
      grid-template-columns: repeat(2, 1fr);
    }
    @include sm {
      grid-template-columns: 1fr;
    }

    .evidence_card {
      position: relative;
      min-height: 136px;
      padding: 16px;
      border: 3px dashed #e2e8f0;

      .evidence_title {
        font-size: 18px;
        font-weight: 700;
        font-family: "Noto Sans TC";
        color: #000000d9;
        line-height: 1.5;
        margin-bottom: 8px;
      }

      .evidence_desc {
        font-size: 14px;
        font-family: "Noto Sans TC";
        color: #64748b;
        line-height: 1.6;
        font-weight: 400;
      }

      .evidence_icon {
        position: absolute;
        right: 16px;
        bottom: 16px;
        width: 58px;
        height: 58px;
      }
    }
  }

  .online_card {
    @include flex_between();
    gap: 24px;
    background: var(--secondary---bg, #f8f6f3);
    padding: 32px;
    margin-bottom: 24px;
    @include md {
      flex-direction: column;
      align-items: flex-start;
    }

    .online_content {
      flex: 1;

      .tag_best {
        display: inline-block;
        background-color: #026764;
        color: #fff;
        font-size: 12px;
        font-weight: 700;
        padding: 4px 12px;
        margin-bottom: 12px;
      }

      .online_title {
        font-size: 24px;
        font-weight: 700;
        font-family: "Noto Sans TC";
        color: #000000d9;
        margin-bottom: 12px;
      }

      .online_desc {
        font-size: 16px;
        font-family: "Noto Sans TC";
        font-weight: 400;
        color: #64748b;
        line-height: 1.6;
        margin-bottom: 20px;

        a {
          color: #64748b;
          text-decoration: underline;
        }
      }

      .online_btn {
        @include flex_center();
        display: inline-flex;
        background-color: $main_color;
        color: #fff;
        padding: 16px 40px;
        font-size: 16px;
        font-weight: 700;
        font-family: "Noto Sans TC";
        white-space: nowrap;
        .online_btn_icon {
          width: 24px;
          height: 24px;
          margin-left: 8px;
        }
        &:hover {
          opacity: 0.85;
        }
      }
    }

    .online_illustration {
      @include flex_center();
      flex-shrink: 0;
      width: 256px;
      height: 192px;
      background-color: #fff;
      border-radius: 4px;

      .online_illustration_img {
        max-width: 100%;
        max-height: 100%;
        object-fit: contain;
      }
    }
  }

  .filing_grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 24px;
    @include md {
      grid-template-columns: 1fr;
    }

    .filing_card {
      background-color: #fff;
      border: 1px solid var(--border, rgba(226, 232, 240, 1));
      padding: 28px;

      .filing_icon {
        @include flex_center();
        width: 48px;
        height: 48px;
        border-radius: 50%;
        background-color: rgba(2, 77, 115, 0.1);
        color: $main_color;
        font-size: 22px;
        margin-bottom: 16px;
      }

      .filing_title {
        font-size: 20px;
        font-weight: bold;
        font-family: "Noto Sans TC";
        color: #000000d9;
        margin-bottom: 12px;
      }

      .filing_desc {
        font-size: 14px;
        font-family: "Noto Sans TC";
        font-weight: 400;
        color: #64748b;
        margin-bottom: 16px;
      }

      .phone_number {
        font-size: 28px;
        font-weight: 900;
        color: $main_color;
        margin-bottom: 16px;
      }

      .filing_desc + .filing_info,
      .phone_number + .filing_info {
        border-top: 1px solid var(--border, rgba(226, 232, 240, 1));
        padding-top: 12px;
      }

      .filing_info {
        gap: 4px;
        margin-bottom: 4px;
        font-family: "Noto Sans TC";
        font-size: 14px;
        font-weight: 400;
        .info_label {
          color: #64748b;
          white-space: nowrap;
        }

        .info_value {
          color: #000000d9;
          font-size: 15px;
          font-weight: 500;
        }
      }
    }
  }
}
</style>
